import { Pipe, PipeTransform } from '@angular/core';
import { Attachment } from '../../core/models/freight-document/Attachment'
import { AttachmentType } from '../../core/models/freight-document/AttachmentType'

@Pipe({
  name: 'annexedDocumentGroups'
})
export class AnnexedDocumentGroupsPipe implements PipeTransform {

  transform(attachments: Attachment[]): Attachment[][] {
    const annexes = (attachments || []).filter(attachment => attachment.type === AttachmentType.ANNEXED_DOCUMENT)
    const groups = new Map<string, Attachment[]>()
    annexes.forEach(annex => {
      const key = annex.groupId || annex.attachmentId
      if (!groups.has(key)) {
        groups.set(key, [])
      }
      groups.get(key).push(annex)
    })
    return Array.from(groups.values())
  }

}
